import React from 'react';

const STEPS = [
  { num: '01', title: 'Consultation', text: 'We meet you on-site or at our office to understand your vision, budget, and timeline in detail.' },
  { num: '02', title: 'Design', text: 'Our architects draft detailed plans with structural and aesthetic inputs aligned to your needs.' },
  { num: '03', title: 'Estimation', text: 'Transparent, itemised cost breakdown — no hidden charges.' },
  { num: '04', title: 'Construction', text: 'Quality execution with skilled teams, premium materials, and real-time project reporting.' },
  { num: '05', title: 'Handover', text: 'Full documentation, quality walkthrough, and post-completion support for total peace of mind.' },
];

export default function Process() {
  return (
    <section id="process" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.84)', overflow: 'hidden' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="reveal" style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto' }}>
          <p style={{
            fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 600,
            letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
          }}>How We Work</p>
          <h2 style={{
            fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
            textTransform: 'uppercase', lineHeight: 1, marginBottom: '1rem'
          }}>
            Our <span style={{ color: 'var(--gold)' }}>Process</span>
          </h2>
          <p style={{ color: 'var(--muted)', fontWeight: 500, lineHeight: 1.7 }}>
            A proven five-step methodology delivering dream homes and commercial structures across Salem & Coimbatore.
          </p>
        </div>

        <div className="proc-track" style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', marginTop: '4rem', position: 'relative' }}>
          <div className="proc-line" style={{
            position: 'absolute', top: 40, left: '10%', right: '10%', height: 1,
            background: 'linear-gradient(to right, transparent, var(--gold), transparent)'
          }} />
          {STEPS.map((s, i) => (
            <div key={s.num} className="reveal" style={{ textAlign: 'center', padding: '0 1rem', transitionDelay: `${i * 0.1}s` }}>
              <div style={{
                width: 80, height: 80, border: '1.5px solid var(--gold)', borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 1.5rem', background: 'rgba(250,250,250,0.8)', position: 'relative', zIndex: 1
              }}>
                <span style={{ fontFamily: 'var(--fh)', fontSize: '1.5rem', fontWeight: 800, color: 'var(--gold)' }}>{s.num}</span>
              </div>
              <div style={{
                fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 700,
                textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.5rem'
              }}>{s.title}</div>
              <p style={{ fontSize: '0.8rem', color: 'var(--muted)', lineHeight: 1.6 }}>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media(max-width:900px){.proc-track{grid-template-columns:1fr 1fr!important;gap:2rem}.proc-line{display:none}}
        @media(max-width:500px){.proc-track{grid-template-columns:1fr!important}}
      `}</style>
    </section>
  );
}
